const LocalStorageText = {
    Token: 'token'
}

const InitState = 'init'

const apiGetFile = "https://qafqtior.digiin.vn/"
//const apiGetFile = 'https://digiin.vn';

export { LocalStorageText, InitState, apiGetFile }